import {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import "./index.less";

export interface CardTitleRef {
  rename: () => void;
}

interface CardTitleProps {
  initialText: string;
  maxLength: number;
  inputBlur: (newTitle: string) => Promise<void>;
}

const CardTitle = forwardRef<CardTitleRef, CardTitleProps>((props, ref) => {
  const { initialText, maxLength, inputBlur } = props;
  const [hasFocus, setHasFocus] = useState<boolean>(false);
  const [text, setText] = useState(initialText);
  const inputRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    setText(initialText);
  }, [hasFocus, initialText]);

  const handleBlur = () => {
    setHasFocus(false);
    inputBlur(text);
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newText = e.target.value;
    setText(newText);
  };


  useImperativeHandle(ref, () => ({
    rename: async () => {
      setHasFocus(true);
      setTimeout(() => {
        inputRef.current?.focus();
        inputRef.current?.select();
      }, 120);
    },
  }));

  return (
    <div className="editable-container"
      onClick={(e) => {
        if (hasFocus) e.stopPropagation();
      }}>
      {hasFocus ? (
        <textarea
          ref={inputRef}
          value={text}
          maxLength={maxLength}
          onBlur={handleBlur}
          onChange={handleChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              inputRef.current?.blur();
            }
          }}
          className="editable-text editing w-full resize-none"
        />
      ) : (
        <div className="editable-text">
          {text}
        </div>
      )}
    </div>
  );
});

export default CardTitle;
